@if (order) {
<!-- CTAs on top of component -->
@if (cancelOrdersAllowed && (hasItemEditable || allItemsEditable) && !isOrderClosed) {
<div class="cancel-items-cta">
  @if (hasItemEditable) {
  <button
    class="btn secondary-btn"
    [disabled]="consignmentEntryControl.invalid"
    (click)="toggleCancelEditModal('cancel-selected-items')"
  >
    {{ 'myAccount.orderDetails.cancelSelected' | cxTranslate }}
  </button>
  } @if (allItemsEditable) {
  <button class="btn secondary-btn" (click)="toggleCancelEditModal('cancel-order')">
    {{ 'myAccount.orderDetails.cancelOrder' | cxTranslate }}
  </button>
  }
</div>
}
<!-- Consignment -->
<mat-selection-list [formControl]="consignmentEntryControl" class="p-0">
  @for (consignment of order.consignments; track consignment) {
  <div class="order-entry">
    <div class="consignment-status" [ngClass]="activeCountry$ | async">
      @if (features?.showCreditOrderConsignmentStatus && consignment?.statusCode === consignmentsStatus.SHIPPED) {
      <div class="status status-icon">
        {{ 'myAccount.orderDetails.consignmentSummary.status.returnOrder' | cxTranslate }}
      </div>
      } @else {
      <div class="status status-icon">
        <mat-icon [svgIcon]="getStatusIcon(consignment?.statusCode)"></mat-icon>
        {{ consignment?.statusDisplay }}({{ consignment.entries.length }})
      </div>
      } @if ( (isDownloadInvoiceEnabled$ | async) && consignment?.invoice && consignment?.invoice?.downloadLink !== '' )
      {
      <div class="download">
        <a
          [href]="consignment?.invoice?.downloadLink"
          download=""
          rel="noopener noreffer"
          target="_blank"
          type="application/octet-stream"
        >
          <span class="alt-text">{{
            'myAccount.orderDetails.consignmentSummary.status.downloadInvoice' | cxTranslate
          }}</span>
          <mat-icon class="light" svgIcon="exportfile"></mat-icon>
        </a>
      </div>
      } @if ( (isDownloadTrackAndTraceEnabled$ | async) && consignment?.trackingLink?.length &&
      !features?.hideTrackAndTrace ) {
      <div class="tracking">
        <cx-generic-link [url]="consignment?.trackingLink" target="_blank">
          <span class="alt-text">{{
            'myAccount.orderDetails.consignmentSummary.status.trackAndTrace' | cxTranslate
          }}</span>
          <mat-icon class="light" svgIcon="track"></mat-icon>
        </cx-generic-link>
      </div>
      } @if (consignment?.shippingAddress?.formattedAddress?.length) {
      <div class="delivery-group">
        <div class="label">{{ 'myAccount.orderDetails.consignmentSummary.status.deliveryLabel' | cxTranslate }}</div>
        <div class="value" [innerHTML]="showAddress(consignment?.shippingAddress) | async"></div>
      </div>
      } @if (consignment?.deliveryDate?.length) {
      <div class="delivery-group delivery-date">
        @if (getDeliveryDateLabelKey(consignment.statusCode); as labelKey) {
        <div class="label">
          {{ labelKey | cxTranslate }}
        </div>
        } @if (consignment?.statusCode !== consignmentsStatus.BACKORDER) {
        <div class="value">
          {{ consignment?.deliveryDate | date : dateFormat() }}
        </div>
        }
      </div>
      } @if ((isTrackingIdEnabled$ | async) && consignment?.trackingID?.length) {
      <div class="delivery-group tracking-id">
        <div class="label">{{ 'myAccount.orderDetails.consignmentSummary.status.trackingId' | cxTranslate }}</div>
        <app-tooltip-text
          class="tracking-id-value"
          [tooltipContent]="consignment?.trackingID"
          [content]="consignment?.trackingID"
          placement="bottom"
        ></app-tooltip-text>
      </div>
      }
    </div>
    <!-- Consignment Entry -->
    <div class="consignment-entry">
      @for (item of consignment.entries; track item; let i = $index; let last = $last) {
      <hr class="line-summary" />
      <div
        class="entry"
        [class.entry-overlay]="
          item.orderEntry?.changesPending || consignment?.statusCode === consignmentsStatus.CANCELLED
        "
      >
        @if (cancelOrdersAllowed && showCancelEditCTA(item, consignment?.statusCode)) {
        <mat-list-option
          class="entry-checkbox"
          [value]="item.orderEntry"
          [disabled]="item.orderEntry?.changesPending"
        ></mat-list-option>
        }
        <div class="image">
          <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: item.orderEntry.product } | cxUrl">
            <cx-media
              [container]="
                item.orderEntry?.product?.images
                  ? getImageRendition((item.orderEntry?.product?.images)[0])
                  : { src: 'https://via.placeholder.com/72' }
              "
              format="product"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
          </a>
        </div>
        <div class="entry-info">
          <div class="code">{{ item?.orderEntry?.product?.code }}</div>
          <div class="name">
            <a
              class="cx-link"
              [routerLink]="{ cxRoute: 'product', params: item.orderEntry.product } | cxUrl"
              [innerHTML]="item?.orderEntry?.product?.name"
            ></a>
          </div>
          @if (item?.orderEntry?.product?.superCategories) {
          <div class="global-variant">
            @for ( variant of checkVariant(item?.orderEntry?.product?.superCategories); track variant; let index =
            $index; let last = $last) { @if (!last) {
            {{ variant.parentCategoryName }}: {{ variant.name }}; } @else { {{ variant.parentCategoryName }}:
            {{ variant.name }}
            } }
          </div>
          } @if (item?.orderEntry?.leadTime && consignment?.statusCode === consignmentsStatus.BACKORDER) {
          <div class="lead-time">
            {{ 'cart.cartItem.delivery.value.days' | cxTranslate : { time: item?.orderEntry?.leadTime } }}
          </div>
          }
        </div>
        @if (item?.orderEntry?.leadTime && consignment?.statusCode === consignmentsStatus.BACKORDER) {
        <div class="lead-time-tablet">
          {{ 'cart.cartItem.delivery.value.days' | cxTranslate : { time: item?.orderEntry?.leadTime } }}
        </div>
        }
        <div class="entry-price" [class.longQtyTextPL]="longQtyText(activeCountry$ | async, activeLanguage$ | async)">
          <div class="dealer-price">
            @if (!showSrp) {
            <div class="label">{{ 'cart.cartItem.itemPrice' | cxTranslate }}</div>
            } @if (!showSrp) {
            <div class="value">
              @if (isActiveCountrySSSC$ | async) { @if (!dealerPrice(item?.orderEntry?.product?.code)) {
              <div class="spinner-shimano-wrapper-dp">
                @if (tooltipIconConfig$ | async; as tooltipIconConfig) { @if (hasDealerPrice) {
                <div class="spinner-shimano">
                  <div class="spinner-shimano-mt-ml"></div>
                </div>
                } @if (!hasDealerPrice && !tooltipIconConfig?.enabled) {
                <div class="no-dealer-price no-dealer-price-cs-cm"></div>
                } @else { @if (!hasDealerPrice && tooltipIconConfig?.enabled) {
                <app-tooltip-icon
                  [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                  dealerPriceIconContainerClass="no-dealer-price-cs-cm"
                  placement="bottom-right"
                  [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                  [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                ></app-tooltip-icon>
                } } }
              </div>
              } @else {
              {{ item?.orderEntry?.product?.price?.formattedValue }}@if
              (item?.orderEntry?.product?.price?.formattedValue && showGstExclusive$ | async) {
              <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
              } } } @else {
              {{ item?.orderEntry?.product?.price?.formattedValue }}@if
              (item?.orderEntry?.product?.price?.formattedValue && showGstExclusive$ | async) {
              <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
              } }
            </div>
            }
          </div>
          <div class="qty">
            @if ((isCustomTranslationsEnabled$ | async) !== null) {
            <div class="label">
              {{
                'cart.cartItem.quantity'
                  | cxTranslate
                    : {
                        context: setCustomContext(
                          isCustomTranslationsEnabled$ | async,
                          activeCountry$ | async,
                          activeLanguage$ | async
                        )
                      }
              }}
            </div>
            }
            <div class="value">
              {{ item?.orderEntry?.quantity }}
            </div>
          </div>
          <div class="total">
            @if (!showSrp) {
            <div class="label">{{ 'cart.cartItem.total' | cxTranslate }}</div>
            } @if (!showSrp) {
            <div class="value">
              <b>{{ item?.orderEntry?.totalPrice?.formattedValue }}</b>
              @if (item?.orderEntry?.totalPrice?.formattedValue && showGstInclusive$ | async) {
              <span class="gst-label">{{ 'gst.inclusive' | cxTranslate }}</span>
              }
            </div>
            }
          </div>
        </div>
        <!-- CTAs per item line -->
        @if (showCancelEditCTA(item, consignment?.statusCode)) {
        <div class="entry-cta">
          @if (editOrdersAllowed) {
          <button
            type="button"
            (click)="toggleCancelEditModal('edit-item-qty', item.orderEntry, getEditItemModalData(item))"
          >
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
          } @if (cancelOrdersAllowed) {
          <button
            class="entry-cta-cancel"
            type="button"
            (click)="toggleCancelEditModal('cancel-selected-items', item.orderEntry)"
          >
            <mat-icon svgIcon="modal-x-icon"></mat-icon>
          </button>
          }
        </div>
        }
      </div>
      }
    </div>
    <hr class="line-summary" />
    <div class="consignment-total">
      <div class="label">
        <b>{{ 'cart.cartItem.total' | cxTranslate }}</b
        >@if (showGstInclusive$ | async) {
        <span class="gst-label">{{ 'gst.inclusive' | cxTranslate : { context: 'parenthetical' } }}</span>
        }
      </div>
      @if (!showSrp) {
      <div class="value">
        <b>{{ consignment?.totalPrice?.formattedValue }}</b>
      </div>
      }
    </div>
  </div>
  }
</mat-selection-list>
} @else {
<div class="results-spinner">
  <mat-spinner [diameter]="72"></mat-spinner>
</div>
}
